import { Editor } from '@tiptap/core';

import { tiptapJsonToMarkdown } from './tiptapJsonToMarkdown';

export const getTiptapMarkdownContentFromEditor = (
  editor?: Editor | null,
): string => {
  if (!editor) {
    return '';
  }

  // @tiptap/markdown augments the editor with getMarkdown() when the Markdown
  // extension is loaded. It serializes ProseMirror JSON → markdown directly,
  // preserving task lists, empty paragraphs, and other structures. We type it
  // locally so this util doesn't need to depend on @tiptap/markdown.
  const withMarkdown = editor as Editor & { getMarkdown?: () => string };
  if (typeof withMarkdown.getMarkdown === 'function') {
    // The editor always carries a trailing empty paragraph for the cursor, which
    // serializes to trailing newlines that aren't real note content. Trim them so
    // a loaded note round-trips without gaining blank lines (matches v2 behavior).
    return withMarkdown.getMarkdown().trimEnd();
  }

  // Fallback for editors without the Markdown extension.
  const markdown = tiptapJsonToMarkdown({ jsonContent: editor.getJSON() });
  return markdown.ok ? (markdown.result ?? '') : '';
};
